import '@splidejs/react-splide/css';
import '@splidejs/react-splide/css/core';

import Carousel from "./carousel"

export default Carousel
